import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Parse a date string safely. For date-only strings (YYYY-MM-DD),
 * appends T00:00:00 to avoid UTC interpretation that can shift the
 * calendar date by one day in negative UTC offset timezones.
 */
function parseDateSafe(dateStr: string): Date {
  // Date-only format: YYYY-MM-DD (no time component)
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    return new Date(`${dateStr}T00:00:00`);
  }
  return new Date(dateStr);
}

/**
 * Format a date string using Intl.DateTimeFormat for a given locale.
 * Falls back to the raw string if parsing fails.
 */
export function formatDate(
  dateStr: string,
  locale: string,
  options?: Intl.DateTimeFormatOptions,
): string {
  try {
    const date = parseDateSafe(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    return new Intl.DateTimeFormat(locale, {
      year: "numeric",
      month: "short",
      day: "numeric",
      ...options,
    }).format(date);
  } catch {
    return dateStr;
  }
}
